<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Medicamentos"
        >
            <rkm-form
                ref="RkmForm"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input-autocomplete
                            :repository="repositories.material"
                            :request-query-string-params="requestQueryStringParams"
                            :search-fields="fields"
                            :text-field="(item) => item.descricaoCompleta"
                            :validations="validations.material"
                            label="Material"
                            v-model="model.material"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="model.estoque"
                            disabled
                            label="Estoque"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-button
                                    :disabled="!model.material"
                                    @click="loadEstoque"
                                    color="primary"
                                    title="Atualizar estoque"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="sync-alt" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.quantidade"
                            label="Quantidade"
                            type="number"
                            v-model="model.quantidade"
                        >
                            <rkm-input-group-append
                                slot="append"
                            >
                                <rkm-button
                                    :disabled="!quantidadeValida"
                                    @click="$refs.ModalLote.open(model.entradaItens)"
                                    title="Visualizar lotes"
                                    v-rkm-tooltip.hover
                                >
                                    <rkm-icon icon="box-open" />
                                </rkm-button>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>

                <rkm-button
                    @click="include"
                    color="primary"
                >
                    Incluir
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalLote
            :model="model"
            ref="ModalLote"
        />
    </div>
</template>

<script>
// Components.
import ModalLote from '@/components/almoxarifado/components/lote/Modal'

// Mixins.
import {error, repository} from '@/mixins'

//Vuex
import {mapActions} from 'vuex'

export default {
    components: {ModalLote},
    computed: {
        requestQueryStringParams() {
            return {
                almoxarifado_check_controle_estoque: true,
                load_entradas: false,
            }
        },
        validations() {
            return {
                material: {required: true},
                quantidade: {
                    required: !!this.model.material,
                    min_value: 1,
                    max_value: this.model.estoque,
                },
            }
        },
        quantidadeValida() {
            const quantidade = parseInt(this.model.quantidade)

            return quantidade > 0 && quantidade <= this.model.estoque
        },
    },
    created() {
        this.repositories = {
            material: this.getConectaSusRepository('cadastro.material'),
        }
    },
    data: () => ({
        fields: [
            {key: "codigo_material", searchable: true},
            {key: "descricao", searchable: true},
        ],
        form: {
            possuiEntradaComLote: false,
        },
        model: {
            entradaItens: [],
            escolheuEntradaItemManualmente: null,
            estoque: null,
            material: null,
            quantidade: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.resetForm()
            this.$refs.RkmModal.show()
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.data.model.medicamentos.find(medicamento => medicamento.id === this.model.material.id)) {
                        this.showValidationNotification('O medicamento já foi incluído.')
                        return
                    }

                    this.data.model.medicamentos.push({
                        id: this.model.material.id,
                        descricaoCompleta: this.model.material.descricaoCompleta,
                        quantidade: this.model.quantidade,
                        escolheuEntradaItemManualmente: this.model.escolheuEntradaItemManualmente,
                        entradaItens: this.model.entradaItens,
                    })

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.form.possuiEntradaComLote = false
            this.model.entradaItens = []
            this.model.escolheuEntradaItemManualmente = null
            this.model.estoque = null
            this.model.material = null
            this.model.quantidade = null
        },
        loadEstoque() {
            this.form.possuiEntradaComLote = false
            this.model.entradaItens = []
            this.model.escolheuEntradaItemManualmente = false
            this.model.estoque = 0
            this.model.quantidade = null

            this.setLoading()

            this.repositories.material.getEstoque(this.model.material.id)
                .then(({data}) => {
                    this.form.possuiEntradaComLote = data.possuiEntradaComLote
                    this.model.estoque = data.total
                    this.model.entradaItens = data.porEntrada.map(estoqueEntrada => {
                        estoqueEntrada.quantidadeSaida = 0
                        return estoqueEntrada
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectEntradaItens() {
            this.model.escolheuEntradaItemManualmente = false
            this.model.entradaItens.map(e => e.quantidadeSaida = 0)

            let quantidade = parseInt(this.model.quantidade)
            let i = 0

            while (quantidade > 0) {
                const entradaItem = this.model.entradaItens[i]
                const estoque = parseInt(entradaItem.estoque)

                if (quantidade > estoque) {
                    entradaItem.quantidadeSaida = estoque
                    quantidade -= estoque
                } else {
                    entradaItem.quantidadeSaida = quantidade
                    quantidade = 0
                }

                i++
            }
        },
    },
    mixins: [error, repository],
    props: {
        data: {type: Object, required: true},
    },
    watch: {
        'model.material'(value) {
            this.form.possuiEntradaComLote = false
            this.model.entradaItens = []
            this.model.escolheuEntradaItemManualmente = false
            this.model.estoque = 0
            this.model.quantidade = null

            if (value && value.id) {
                this.loadEstoque()
            }
        },
        'model.quantidade': function () {
            if (this.form.possuiEntradaComLote && this.quantidadeValida) {
                this.selectEntradaItens()
            }
        },
    },
}
</script>